import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { History } from "lucide-react";

export default function AuditLog() {
  const [list, setList] = useState([]);
  useEffect(() => { api.audit({ limit: 300 }).then(setList).catch(() => {}); }, []);

  const actionColor = (a) => {
    if (a === "create") return "text-emerald-400";
    if (a === "delete") return "text-red-400";
    if (a === "approval") return "text-sky-400";
    if (a === "submit") return "text-sky-400";
    return "text-slate-300";
  };

  return (
    <div className="space-y-6">
      <div className="flex items-end justify-between">
        <div>
          <div className="font-mono text-xs uppercase tracking-widest text-slate-500">Compliance</div>
          <h1 className="font-heading text-3xl md:text-4xl font-black tracking-tighter text-slate-50">Audit Log</h1>
        </div>
        <div className="font-mono text-[11px] text-slate-500">{list.length} entries</div>
      </div>

      <div className="panel p-4">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-[10px] uppercase tracking-widest text-slate-500 font-mono">
              <th className="text-left pb-2">Timestamp</th><th className="text-left pb-2">User</th><th className="text-left pb-2">Action</th><th className="text-left pb-2">Entity</th><th className="text-left pb-2">Reason</th>
            </tr>
          </thead>
          <tbody>
            {list.map(r => (
              <tr key={r.id} className="border-b border-[#1E293B] hover:bg-[#0E1522]" data-testid={`audit-row-${r.id}`}>
                <td className="font-mono py-2 text-[11px] text-slate-500">{r.ts?.slice(0, 19).replace("T", " ")}</td>
                <td className="font-mono py-2 text-slate-400">{r.user}</td>
                <td className={`font-mono py-2 uppercase text-[11px] ${actionColor(r.action)}`}>{r.action}</td>
                <td className="font-mono py-2 text-slate-400">{r.entity_type} <span className="text-slate-600">·</span> {r.entity_id?.slice(0, 8)}</td>
                <td className="py-2 text-slate-500 text-[11px]">{r.reason}</td>
              </tr>
            ))}
            {list.length === 0 && <tr><td colSpan={5} className="text-slate-500 py-3 text-sm flex items-center gap-2"><History size={14} /> No audit entries.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
